<template>
  <div class="h-full">
    <div class="bonus-table relative h-full">
      <div class="table-header h-[34px]">
        <div class="th">{{ t('vipBonusMonthly.level') }}</div>
        <div class="th">{{ t('vipBonusMonthly.monthlyBonus') }}</div>
      </div>
      <div class="overflow-y-auto h-[calc(100%-34px)] !text-[10px]">
        <div v-for="(row, idx) in monthlyData" :key="idx" :class="['table-row', { zebra: idx % 2 != 1 }]">
          <div class="td" style="display: flex; align-items: center; justify-content: center;">
            <img :src="imgUrl + row.icon" alt="" class="w-[auto] h-[18px] " />
          </div>
          <div class="td color-[#FEF64A] " style="font-size:10px;">
            <div v-if="IS_DOUBLE_WALLET">
              <div>{{ numberFormat(row.reward) }}</div>
            </div>
            <div v-else class="flex items-center justify-center">
              <div v-if="row.reward">{{ VITE_SYMBOL }} {{ numberFormat(row.reward) }}<span v-if="row.rewardBound">({{
                  t('cash') }})</span></div>
              <div v-if="row.rewardBound" class="ml-[10px]">{{ numberFormat(row.rewardBound) }}<span
                  v-if="row.reward">({{ t('bonus') }})</span></div>
              <div v-if="!row.reward && !row.rewardBound">{{ VITE_SYMBOL }} {{ numberFormat(row.reward) }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="lingqu" :class="{ 'from-person': isFromPerson }">
      <Button type="long" class="linqubtn" :disabled="!canDrawReward">{{
        t('vipBonusMonthly.claimMonthlyReward') }}</Button>
    </div>
    <Teleport to="body">
      <div class="lingqu pop" :class="{ 'from-person': isFromPerson }" @click="handleDrawReward">

      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { ref, onMounted, computed } from 'vue'
import { numberFormat } from '@/utils/formatter'
import { useRoute } from 'vue-router'
import { useVipStore } from '@/stores/modules/vip'
import * as GameApi from '@/api/game'
import { useI18n } from 'vue-i18n'

// 定义props和emits
const props = defineProps<{
  showRewardDialog: boolean
  rewardAmount: string
}>()

const emit = defineEmits<{
  'show-reward': [amount: string]
  'reward-confirmed': []
}>()

const { t } = useI18n()
const route = useRoute()
const imgUrl = import.meta.env.VITE_IMG_URL
const vipStore = useVipStore()
const IS_DOUBLE_WALLET = import.meta.env.VITE_WALLET_SWITCH == 'true' ? true : false;
const VITE_SYMBOL = import.meta.env.VITE_SYMBOL
// 判断是否从个人中心跳转
const isFromPerson = computed(() => {
  return route.path === '/activity' &&
    route.query.tab === 'vip' &&
    sessionStorage.getItem('fromPerson') === 'true'
})

// 使用store中的月奖励数据
const monthlyData = computed(() => vipStore.monthlyRewardData)

// 检查是否可以领取月奖励
const canDrawReward = computed(() => {
  const drawRewardList = vipStore.vipData.drawRewardList || []
  return drawRewardList.includes(4)
})

// 领取月奖励
const drawReward = () => {
  GameApi.drawReward({ type: 4 }).then(res => {
    // 显示奖励弹窗
    const amount = res.data || '0,00'
    emit('show-reward', amount)
  }).catch(err => {
    console.error('领取失败:', err)
  })
}

// 处理领取奖励的点击事件
const handleDrawReward = () => {
  if (canDrawReward.value) {
    drawReward()
  }
}
</script>

<style scoped>
.table-header {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #60B289;
  font-size: 12px;
  font-weight: 500;
  gap: 0;

}

.th {
  flex: 1;
  text-align: center;
  padding: 8px 0;
}

.table-row {
  display: flex;
  font-size: 12px;
  color: #fff;
  align-items: center;
  min-height: 34px;
}

.table-row .td {
  flex: 1;
  text-align: center;
  padding: 5px 0;
  font-size: 12px;
}

.table-row.zebra {
  background: rgba(8, 44, 33, 0.3);
}

.lingqu {
  position: fixed;
  bottom: 50px;
  /* 直接使用固定值，避免动态计算 */
  left: 0;
  background: linear-gradient(180deg, #00554A 0%, #082C21 100%);
  height: max(60px, env(safe-area-inset-bottom) + 130px);
  /* line-height: 80px; */
  text-align: center;
  width: 100%;
  z-index: 1;
  padding-bottom: max(60px, env(safe-area-inset-bottom) + 50px);
  /* border-top: 1px solid #009F76; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.lingqu.pop {
  background: transparent;
  z-index: 1000;
  height: 60px !important;
  padding-bottom: 0 !important;
  bottom: 70px;
}

.lingqu.pop.from-person {
  bottom: 0px !important;
  z-index: 0 !important;
}

/* 从个人中心跳转时的特殊样式 */
.lingqu.from-person {
  height: max(60px, env(safe-area-inset-bottom) + 50px) !important;
  bottom: 0 !important;
  padding-bottom: 0 !important;
  /* 定位到屏幕底部，因为底部tab被隐藏了 */
}

/* 只在真正需要的时候才使用安全区域 */
@supports (padding: max(0px)) {
  .lingqu {
    bottom: max(0px, env(safe-area-inset-bottom));
  }

  .lingqu.from-person {
    bottom: max(0px, env(safe-area-inset-bottom));
  }
}


.linqubtn {
  height: 41px;
  line-height: 41px;
  width: 80%;
  background: linear-gradient(0deg, #796F22 0%, #7D7B38 100%);
  border-radius: 7px;
  color: #ABA778;
  font-size: 12px;
  transition: all 0.3s ease;
  cursor: not-allowed;
}

.linqubtn.active {
  background: linear-gradient(0deg, #FABD63 0%, #F19C32 100%);
  color: #FEFBCB;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(254, 246, 74, 0.3);
  cursor: pointer;
}
</style>
